import { assets, SITE } from "@/lib/config";
import { cn } from "@/lib/utils";

/**
 * Brand mark — the original supplied logo file, displayed via CSS crop.
 * The artwork itself is never recreated or embedded.
 */
export function LogoMark({ className, testId }: { className?: string; testId?: string }) {
  return (
    <span
      data-testid={testId}
      className={cn("relative block h-9 w-9 shrink-0 overflow-hidden bg-black", className)}
      aria-hidden="true"
    >
      <img
        src={assets.logo}
        alt=""
        className="absolute left-1/2 top-1/2 h-auto w-[160%] max-w-none -translate-x-1/2 -translate-y-[40%]"
        draggable={false}
      />
    </span>
  );
}

/** Full supplied logo artwork (mark + wordmark plate). */
export function LogoFull({ className }: { className?: string }) {
  return (
    <img
      src={assets.logo}
      alt="Consequence Protocol logo"
      className={cn("h-auto w-auto select-none", className)}
      draggable={false}
    />
  );
}

/** Mark + typographic wordmark, used in navbar and footer. */
export function LogoLockup({ className, testId }: { className?: string; testId?: string }) {
  return (
    <span className={cn("flex items-center gap-3", className)}>
      <LogoMark testId={testId} />
      <span className="flex flex-col leading-none">
        <span className="font-display text-sm font-bold uppercase tracking-[0.22em] text-ink">{SITE.name}</span>
        <span className="mt-1 font-mono text-[8px] uppercase tracking-[0.42em] text-dim">Protocol</span>
      </span>
    </span>
  );
}
